import _ from 'lodash'
import { FeatureAvailability, featuresSchema } from './featuresSchema'

import { FeatureAvailabilities, FeatureName } from './types'
import { isDeveloperEmail, isFeedieEmail } from '@feedyou/utils'

export const isFeaturePublic = (featureName: FeatureName, availabilities: FeatureAvailabilities) =>
  availabilities[featureName] === FeatureAvailability.PUBLIC_BETA

export const isFeaturePrivate = (featureName: FeatureName, availabilities: FeatureAvailabilities) =>
  availabilities[featureName] === FeatureAvailability.PRIVATE_BETA

export const isFeatureInDevelopment = (
  featureName: FeatureName,
  availabilities: FeatureAvailabilities
) => availabilities[featureName] === FeatureAvailability.DEVELOPMENT

export const getBooleanFeatureNames = () => {
  const booleanFeatureDefinitions = _.pickBy(
    featuresSchema,
    featureDefinition => featureDefinition.type === 'boolean'
  )

  return Object.keys(booleanFeatureDefinitions)
}

export function canUserAccessFeature(
  featureName: FeatureName,
  userEmail: string | undefined,
  availabilities: FeatureAvailabilities
): boolean {
  if (isFeatureInDevelopment(featureName, availabilities) && isDeveloperEmail(userEmail)) {
    return true
  }

  if (isFeaturePrivate(featureName, availabilities) && isFeedieEmail(userEmail)) {
    return true
  }

  if (isFeaturePublic(featureName, availabilities)) {
    return true
  }

  return false
}
